export default "__VITE_ASSET__fd089d2d__"